import PropTypes from 'prop-types';

export default function Switch({ name, value, callback, disabled = false, checked = false, testId = '' }) {
	return (
		<input
			type="checkbox"
			name={name}
			value={value}
			disabled={disabled}
			onChange={(e) => {
				callback(e.target.value, e.target.checked);
			}}
			checked={checked}
			data-testid={testId}
		/>
	);
}

Switch.propTypes = {
	callback: PropTypes.func.isRequired,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	name: PropTypes.string.isRequired,
	testId: PropTypes.string,
	value: PropTypes.string.isRequired,
};
